<template>
  <div>
    <div v-if="initProgress" class="w-100 mt-5 mb-5">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>
    <vx-card ref="filterCard" :title="`Exportar productos: ${productsPre.length} en total`"
             class="user-list-filters mb-8"
             collapse-action
             refresh-content-action @refresh="resetFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filtrar por marca</label>
          <v-select label="name" :options="brands" :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="brandFilter" class="mb-4 md:mb-0"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filtrar por categoría</label>
          <v-select label="name" :options="brandsCategories" :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="categoryFilter" class="mb-4 md:mb-0"/>
        </div>
      </div>
      <div class="mt-5">
        <vs-button class="mr-5" :disabled="productsPre.length===0" @click="activePrompt=true">
          Exportar a excel
        </vs-button>
        <vs-button @click="printGo" :disabled="productsPre.length===0||!readyToPrint">Imprimir PDF</vs-button>
      </div>
    </vx-card>
    <vs-prompt title="Exportar a Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel"
               accept-text="Exportar" cancel-text="Cancelar" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" placeholder="Ingresa el nombre del archivo..." class="w-full"/>
      <v-select v-model="selectedFormat" :options="formats" class="my-4"/>
      <div class="flex">
        <span class="mr-4">Auto ajustar columna:</span>
        <vs-switch v-model="cellAutoWidth">Auto ajustar columna</vs-switch>
      </div>
    </vs-prompt>
    <img
        src="https://firebasestorage.googleapis.com/v0/b/kardi-48465.appspot.com/o/content%2Fimagen1.jpeg?alt=media&token=e8ec511a-4f3d-4152-a9db-c6bf4232a187"
        alt="Imagen 1">
    <img
        src="https://firebasestorage.googleapis.com/v0/b/kardi-48465.appspot.com/o/content%2Fimagen2.jpeg?alt=media&token=8ca922b7-47f9-4057-bbae-1da0e5192a0a"
        alt="Image 2">
    <!--Table for print-->
    <div style="display: none">
      <table id="productsTable">
        <tr>
          <th>Imagen</th>
          <th>SKU</th>
          <th>Nombre</th>
          <th>Marca</th>
          <th>Categoría</th>
          <th>Stock</th>
          <th>Estado</th>
        </tr>
        <template v-for="(tr, indextr) in productsPre">
          <tr v-if="tr.state" :key="indextr">
            <td style="padding:0 15px" class="img-container">
              <img style="height: 50px;width: 50px; object-fit: contain; border-radius: 50%" v-if="tr.image1"
                   class="product-img"
                   :src="tr.image1"
                   alt="Imagen de producto">
              <span v-else>NN</span>
            </td>

            <td>
              <p class="product-name font-medium truncate">{{ tr.sku }}</p>
            </td>

            <td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </td>

            <td>
              <p class="product-name font-medium truncate">{{ tr.brand.name }}</p>
            </td>

            <td>
              <p class="product-name font-medium truncate">{{ tr.category.name }}</p>
            </td>

            <td>
              <p class="product-name font-medium truncate">{{ tr.stock }}</p>
            </td>

            <td>
              <p class="product-name font-medium truncate"> {{ tr.stateText.label }}</p>
            </td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
const firebase = require("firebase/app")
// Required for side-effects
require("firebase/firestore")
let db = firebase.firestore()
import vSelect from 'vue-select'

export default {
  name: "Home",
  data() {
    return {
      //Filters
      brands: [],
      brandsCategories: [],
      categories: [],
      categoryFilter: {},
      brandFilter: {},
      productsPre: [],
      readyToPrint: false,
      // Export
      fileName: '',
      formats: ['xlsx'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      headerTitle: ['Nombre', 'SKU', 'Stock', 'Marca', 'Categoría', 'Estado'],
      headerVal: ['name', 'sku', 'stock', 'brand', 'category', 'state'],
      activePrompt: false,
      initProgress: false
    }
  },
  components: {
    vSelect
  },
  async created() {
    try {
      await this.loadProducts()
      await this.loadBrands()
    } catch (e) {
      console.log(e)
    }
  },
  watch: {
    async brandFilter(val) {
      try {
        if (val) {
          this.initProgress = true
          this.productsPre = []
          this.readyToPrint = false
          db.collection("products")
              .where('brand.id', '==', this.brandFilter.id)
              .where('state', '==', true)
              .orderBy('createdAt', 'desc').get().then(async (querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let product = {
                id: doc.id,
                ...doc.data(),
                image1: doc.data().image1 || null,
                image2: doc.data().image2 || null
              }
              this.productsPre.push(product)
            })
            await this.loadCategoryBrands()
            setTimeout(() => {
              this.readyToPrint = true
              this.initProgress = false
            }, 5000)
          }).catch((e) => {
            console.log(e)
            this.$vs.notify({
              color: 'warning',
              title: '¡Oh no!',
              text: 'Hubo un error.'
            })
          })
        }
      } catch (e) {
        this.initProgress = false
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    async categoryFilter(val) {
      if (val) {
        this.initProgress = true
        this.productsPre = []
        this.readyToPrint = false
        await this.$store.dispatch('products/fetchProducts', {products: this.productsPre})
        db.collection("products")
            .where('category.id', '==', this.categoryFilter.id)
            .where('brand.id', '==', this.brandFilter.id)
            .where('state', '==', true)
            .orderBy('createdAt', 'desc').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let product = {
              id: doc.id,
              ...doc.data(),
              image1: doc.data().image1 || null,
              image2: doc.data().image2 || null
            }
            this.productsPre.push(product)
          })
          this.$store.dispatch('products/fetchProducts', {products: this.productsPre})
          setTimeout(() => {
            this.readyToPrint = true
            this.initProgress = false
          }, 5000)
        }).catch((e) => {
          console.log(e)
          this.initProgress = false
          this.$vs.notify({
            color: 'warning',
            title: '¡Oh no!',
            text: 'Hubo un error.'
          })
        })
      }
    }
  },
  methods: {
    async loadProducts() {
      this.productsPre = []
      this.$store.dispatch('products/fetchProducts', {products: this.productsPre})
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, rejected) => {
        if (this.$acl.check('admin')) {
          this.initProgress = true
          this.readyToPrint = false
          db.collection("products")
              .where('state', '==', true)
              .orderBy('createdAt', 'desc').get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let product = {
                id: doc.id,
                ...doc.data(),
                image1: doc.data().image1 || null,
                image2: doc.data().image2 || null
              }
              this.productsPre.push(product)
            })
            setTimeout(() => {
              this.readyToPrint = true
              this.initProgress = false
            }, 10000)
            resolve('ok')
            this.$store.dispatch('products/fetchProducts', {products: this.productsPre})
          }).catch((error) => {
            this.$vs.notify({
              color: 'warning',
              title: '¡Oh no!',
              text: 'Hubo un error.'
            })
            rejected(error)
          })
        } else {
          this.initProgress = true
          this.readyToPrint = false
          const querySnapUsers = await db.collection('users').where('uid', '==', firebase.auth().currentUser.uid).get()
          let user = {}
          querySnapUsers.forEach((doc) => {
            user = {
              id: doc.id,
              ...doc.data()
            }
          })
          const clientDoc = await db.collection('clients').doc(user.client.id).get()
          // Get products
          const products = []
          this.brands = [...clientDoc.data().brand]
          for await(let brand of clientDoc.data().brand) {
            const querySnapProducts = await db.collection('products')
                .where('brand.id', '==', brand.id + "")
                .where('state', '==', true).get()
            querySnapProducts.forEach((doc) => {
              const obj = {
                id: doc.id,
                ...doc.data(),
                image1: doc.data().image1 || null,
                image2: doc.data().image2 || null
              }
              products.push(obj)
            })
          }
          this.productsPre = [...products]
          await this.$store.dispatch('products/fetchProducts', {products: this.productsPre})
          setTimeout(() => {
            this.readyToPrint = true
            this.initProgress = false
          }, 5000)
          resolve('ok')
          // End
        }
      })
    },
    loadBrands() {
      return new Promise((resolve, rejected) => {
        if (this.$acl.check('admin')) {
          db.collection("brands").where('state', '==', true).orderBy('createdAt', 'desc').get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let brand = {
                id: doc.id,
                ...doc.data()
              }
              this.brands.push(brand)
            })
            resolve('ok')
          }).catch((error) => {
            rejected(error)
          })
        }
      })
    },
    async loadCategoryBrands() {
      try {
        if (this.brandFilter) {
          this.brandsCategories = []
          const querySnap = await db.collection('categories').where('brand.id', '==', this.brandFilter.id).get()
          querySnap.forEach((doc) => {
            const obj = {
              id: doc.id,
              ...doc.data()
            }
            this.brandsCategories.push(obj)
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    exportToExcel() {
      import('@/vendor/Export2Excel').then(excel => {
        const list = []
        this.productsPre.forEach((p) => {
          let product = {
            name: p.name,
            sku: p.sku,
            stock: p.stock,
            brand: p.brand.name,
            category: p.category.name,
            state: p.stateText.label
          }
          list.push(product)
        })
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    clearFields() {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    printGo() {
      let divToPrint = document.getElementById("productsTable");
      let newWin = window.open("");
      newWin.document.write(divToPrint.outerHTML);
      newWin.print();
      newWin.close();
    },
    async resetFilters() {
      this.initProgress = true
      await this.loadProducts()
      this.initProgress = false
      this.brandFilter = null
      this.categoryFilter = null
      this.brandsCategories = []
      this.$refs.filterCard.removeRefreshAnimation()
    }
  }
}
</script>

<style scoped>

</style>
